module.exports = __webpack_public_path__ + "media/icons/etoile-51c420db.svg";